import { ActionType } from 'typesafe-actions';
import * as authActionCreators from './actions';
import reducer from './reducer';

export default reducer;

export const actions = authActionCreators;

export * from './types';
export type AuthActions = ActionType<typeof authActionCreators>;
